//使用方法
/**
 * 获取枚举值：STATUSMAP.SH
 * 获取枚举描述：STATUSMAP.getDesc('SH')
 * 通过枚举值获取描述：STATUSMAP.getDescFromValue('TG')
 */

let STATUSMAP = createEnum({
  NI: ['身份证'],
  PP: ['护照'],
  GA: ['港澳台通行'],
  TW: ['台湾通行证'],
  TB: ['台胞'],
  HX: ['回乡'],
  HY: ['海员'],
  HR: ['户口簿'],
  JR: ['军人'],
  BC: ['出生证明'],
  FI: ['外国人永久居留证'],
  HM: ['港澳合居民居住证'],
})

function createEnum(definition) {
  const valueMap = {}
  const descMap = {}
  for (const key of Object.keys(definition)) {
    const [value, desc] = definition[key]
    valueMap[key] = value
    descMap[value] = desc
  }
  return {
    ...valueMap,
    getDesc(key) {
      return (definition[key] && definition[key][1]) || '无'
    },
    getDescFromValue(value) {
      return descMap[value] || '无'
    }
  }
}

export default STATUSMAP
